import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Socket } from 'ngx-socket-io';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from '../login/auth.service';
import { AppState } from '../redux/app.state';
import {
  CarModel,
  CreateCarModelDto,
  SearchCarModelDto,
  UpdateCarModelDto,
  User
} from 'src/typings';

@Injectable({
  providedIn: 'root'
})
export class CarModelService {
  user: User | undefined;

  carModelGW = this.socket.fromEvent<CarModel>('newCarModel');

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private store: Store<AppState>,
    private socket: Socket
  ) {
    this.store.subscribe((data) => {
      this.user = data.user.info;
    });
  }

  search(payload?: SearchCarModelDto): Observable<{ data: CarModel[]; length: number }> {
    return this.http
      .post<{ data: CarModel[]; length: number }>(
        `${environment.BACKEND}/car-model/search`,
        payload
      )
      .pipe(
        map((row) => {
          return {
            ...row,
            data: row.data.map((row2) => {
              return {
                ...row2,
                manufacture_date_from: new Date(row2.manufacture_date_from),
                manufacture_date_to: row2.manufacture_date_to && new Date(row2.manufacture_date_to)
              };
            })
          };
        })
      );
  }

  create(payload: CreateCarModelDto): Observable<CarModel> {
    return this.http.post<CarModel>(`${environment.BACKEND}/car-model/create`, payload);
  }

  update(payload: UpdateCarModelDto): Observable<CarModel> {
    return this.http.put<CarModel>(`${environment.BACKEND}/car-model/update`, payload);
  }

  delete(id: number) {
    return this.http.delete(`${environment.BACKEND}/car-model/${id}`);
  }
}
